var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangleWarning = function SvgTriangleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FABB09",
    d: "M17.802 13.78c.563 1-.156 2.22-1.313 2.22H1.509C.352 16-.367 14.75.195 13.78L7.701.739c.563-1 2.033-.97 2.596 0zm-8.788-2.721c-.813 0-1.438.657-1.438 1.438 0 .813.625 1.439 1.438 1.439.782 0 1.439-.626 1.439-1.439 0-.781-.657-1.438-1.439-1.438m-1.376-5.16.22 4.253c.03.219.187.344.375.344h1.532c.188 0 .344-.125.375-.344l.22-4.253c.03-.219-.157-.407-.376-.407h-1.97c-.22 0-.407.188-.376.407"
  })));
};
export default SvgTriangleWarning;